var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    winning-way\n    text-center\n    w-full\n    rounded-13\n    overflow-hidden\n    whitespace-nowrap\n  ",class:_vm.type},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }